import { render } from "./Translation.vue?vue&type=template&id=390a1c0e&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"

import "./Translation.vue?vue&type=style&index=0&id=390a1c0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-390a1c0e"

export default script